(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smart-business-configurator-v2"] && !Shopify.designMode) return;
  try {
    function initializeSmartPersonalizers(scope = document) {
scope.querySelectorAll('[data-sbc2]').forEach((root) => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const device = root.querySelector('[data-sbc2-device]');
  const variantSelector = root.closest('form')?.querySelector('[data-smbp-variant]');
  const materialLabel = root.querySelector('[data-sbc2-material-label]');
  const syncMaterial = () => {
    const selected = variantSelector?.selectedOptions?.[0];
    const sku = selected?.dataset?.sku || root.dataset.variantSku || '';
    root.dataset.material = sku.endsWith('-WHT') ? 'white' : sku.endsWith('-WOOD') ? 'wood' : 'black';
    if (selected && materialLabel) materialLabel.textContent = selected.textContent.split(' — ')[0].trim();
  };
  variantSelector?.addEventListener('change', syncMaterial);
  syncMaterial();
  const summary = root.querySelector('[data-sbc2-summary]');
  const summaryFallback = summary.textContent;
  const contactPreview = root.querySelector('[data-sbc2-contact-preview]');
  const destinationPreview = root.querySelector('[data-sbc2-destination-preview]');
  const accent = root.querySelector('[data-sbc2-accent]');
  const designs = root.querySelectorAll('[data-sbc2-design]');
  const colors = { Violet: '#6544d9', Ocean: '#075c92', Forest: '#176243', Amber: '#965312' };
  const textInputs = [...root.querySelectorAll('input:not([type=file]):not([type=password]):not([type=radio]):not([type=checkbox]), textarea')];
  const syncPreview = () => {
    const contact = textInputs.filter((input) => ['properties[Kontaktname]', 'properties[Telefon]', 'properties[E-Mail]'].includes(input.name))
      .map((input) => input.value.trim()).filter(Boolean);
    contactPreview.textContent = contact.join('\n');
    contactPreview.hidden = !contact.length;
    const destination = textInputs.filter((input) => input.type === 'url' || input.name === 'properties[WLAN Name]')
      .map((input) => input.value.trim()).filter(Boolean);
    destinationPreview.textContent = destination.join('\n');
    destinationPreview.hidden = !destination.length;
    const selected = root.querySelector('[data-sbc2-design]:checked');
    device.dataset.design = selected?.value || 'Signature';
    root.style.setProperty('--sbc2-accent', colors[accent.value] || colors.Violet);
    const details = textInputs.filter((input) => input.value.trim()).map((input) => input.value.trim().slice(0, 160));
    summary.textContent = details.length ? [selected?.value, accent.options[accent.selectedIndex].text, ...details].join('\n') : summaryFallback;
  };
  textInputs.forEach((input) => {
    if (input.type !== 'url') input.maxLength = input.tagName === 'TEXTAREA' ? 1000 : 200;
    input.addEventListener('input', syncPreview);
  });
  [...designs, accent].forEach((input) => input.addEventListener('change', syncPreview));
  root.querySelectorAll('input[type=url]').forEach((input) => {
    const validateUrl = () => {
      let valid = !input.value;
      try {
        const url = new URL(input.value);
        valid = url.protocol === 'https:' && !url.username && !url.password;
      } catch {}
      input.setCustomValidity(valid ? '' : root.dataset.urlError);
    };
    input.addEventListener('input', validateUrl);
  });
  syncPreview();
  const firm = root.querySelector('[data-sbc2-firm]');
  const firmPreview = root.querySelector('[data-sbc2-firm-preview]');
  if (firm && firmPreview) {
    const fallback = firmPreview.textContent;
    firm.addEventListener('input', () => {
      firmPreview.textContent = firm.value.trim() || fallback;
    });
  }

  // WLAN passwords are configured securely after purchase in uTraLink; never submit them as Shopify line item properties.

  const contactMethods = [...root.querySelectorAll('[data-sbc2-contact-method]')];
  const form = root.closest('form');
  if (contactMethods.length && form) {
    const validateContacts = () => {
      const valid = contactMethods.some((input) => input.value.trim().length > 0);
      contactMethods[0].setCustomValidity(valid ? '' : root.dataset.contactError || '');
    };
    contactMethods.forEach((input) => input.addEventListener('input', validateContacts));
    form.addEventListener('submit', validateContacts);
    validateContacts();
  }

  const logo = root.querySelector('[data-sbc2-logo]');
  const logoPreview = root.querySelector('[data-sbc2-logo-preview]');
  const removeLogo = root.querySelector('[data-sbc2-remove-logo]');
  if (logo && logoPreview) {
    let objectUrl;
    const clearLogo = () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = undefined;
      logoPreview.hidden = true;
      logoPreview.removeAttribute('src');
      removeLogo.hidden = true;
    };
    removeLogo.addEventListener('click', () => {
      clearLogo();
      logo.value = '';
      logo.setCustomValidity('');
      logo.focus();
    });
    logo.addEventListener('change', () => {
      clearLogo();
      const file = logo.files && logo.files[0];
      logo.setCustomValidity('');
      if (!file) return;
      removeLogo.hidden = false;
      if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
        logo.setCustomValidity(root.dataset.fileError);
        logo.reportValidity();
        return;
      }
      objectUrl = URL.createObjectURL(file);
      logoPreview.src = objectUrl;
      logoPreview.hidden = false;
      removeLogo.hidden = false;
    });
    window.addEventListener('pagehide', clearLogo, { once: true });
  }
});
}
initializeSmartPersonalizers();
document.addEventListener('shopify:section:load', (event) => initializeSmartPersonalizers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smart-business-configurator"] && !Shopify.designMode) return;
  try {
    const updateSmartBusinessPreview = (root) => {
  const firm = root.querySelector('[data-sb-firm]');
  const firmPreview = root.querySelector('[data-sb-firm-preview]');
  if (firm && firmPreview) {
    const defaultFirm = firmPreview.textContent;
    firm.addEventListener('input', () => {
      firmPreview.textContent = firm.value.trim() || defaultFirm;
    });
  }
  const wifiSecurity = root.querySelector('[data-sb-wifi-security]');
  const wifiPassword = root.querySelector('[data-sb-wifi-password]');
  const wifiRequired = root.querySelector('[data-sb-wifi-required]');
  if (wifiSecurity && wifiPassword) {
    const syncWifiRequirement = () => {
      const isOpen = wifiSecurity.value === 'Offen';
      wifiPassword.required = !isOpen;
      if (wifiRequired) wifiRequired.hidden = isOpen;
    };
    wifiSecurity.addEventListener('change', syncWifiRequirement);
    syncWifiRequirement();
  }

  const contactMethods = [...root.querySelectorAll('[data-sb-contact-method]')];
  const form = root.closest('form');
  if (contactMethods.length && form) {
    const validateContactMethods = () => {
      const hasMethod = contactMethods.some((input) => input.value.trim().length > 0);
      contactMethods[0].setCustomValidity(hasMethod ? '' : root.dataset.contactError || '');
    };
    contactMethods.forEach((input) => input.addEventListener('input', validateContactMethods));
    form.addEventListener('submit', validateContactMethods);
    validateContactMethods();
  }

  const logo = root.querySelector('[data-sb-logo]');
  const logoPreview = root.querySelector('[data-sb-logo-preview]');
  if (logo && logoPreview) {
    let objectUrl;
    logo.addEventListener('change', () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      const file = logo.files && logo.files[0];
      if (!file || !file.type.startsWith('image/')) {
        logoPreview.hidden = true;
        logoPreview.removeAttribute('src');
        return;
      }
      objectUrl = URL.createObjectURL(file);
      logoPreview.src = objectUrl;
      logoPreview.hidden = false;
    });
  }
};
document.querySelectorAll('[data-sbconfig]').forEach(updateSmartBusinessPreview);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smart-business-product-personaliser"] && !Shopify.designMode) return;
  try {
    function initializeProductDesigners(scope = document) {
  scope.querySelectorAll('[data-spd]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const defaults = new Map([...root.querySelectorAll('[data-spd-preview]')].map(node => [node, node.textContent]));
    const fields = [...root.querySelectorAll('[data-spd-field]')];
    const colors = { Violet:'#6544d9', Ocean:'#075c92', Forest:'#176243', Amber:'#965312' };
    const contacts = [...root.querySelectorAll('[data-spd-contact]')];
    const variant = root.closest('form')?.querySelector('[data-smbp-variant]');
    if (variant && root.dataset.kind === 'stand') variant.addEventListener('change', () => {
      const sku = variant.selectedOptions[0]?.dataset.sku || '';
      root.dataset.material = sku.endsWith('-WHT') ? 'white' : sku.endsWith('-WOOD') ? 'wood' : 'black';
    });
    const sync = () => {
      fields.forEach(input => {
        const value = input.value.trim();
        root.querySelectorAll(`[data-spd-preview="${input.dataset.spdField}"]`).forEach(node => {
          node.textContent = value || defaults.get(node);
          if (!defaults.get(node)?.trim()) node.hidden = !value;
        });
        const social = root.querySelector(`[data-spd-social="${input.dataset.spdField}"]`);
        if (social) social.hidden = !value || !input.validity.valid;
        if (input.dataset.spdField === 'portfolio') root.querySelector('[data-spd-portfolio]').hidden = !value || !input.validity.valid;
      });
      const name = fields.find(input => input.dataset.spdField === 'name')?.value.trim();
      const monogram = root.querySelector('[data-spd-monogram]');
      if (monogram) monogram.textContent = name ? name.split(/\s+/).slice(0,2).map(word => word[0]).join('').toUpperCase() : 'AL';
      const stage = root.querySelector('[data-spd-stage]');
      stage.dataset.style = root.querySelector('[data-spd-style]:checked')?.value || 'Signature';
      root.querySelector('[data-spd-style-label]').textContent = root.querySelector('[data-spd-style]:checked')?.closest('label').querySelector('strong').textContent || 'Signature';
      root.style.setProperty('--spd-accent', colors[root.querySelector('[data-spd-accent]:checked').value]);
      root.querySelectorAll('[data-spd-row]').forEach(row => { row.hidden = row.querySelector('[data-spd-preview]').hidden; });
      if (contacts.length) contacts[0].setCustomValidity(contacts.some(input => input.value.trim()) ? '' : root.dataset.contactError);
    };
    fields.forEach(input => input.addEventListener('input', () => {
      if (input.type === 'url') {
        let valid = !input.value;
        try { const url = new URL(input.value); valid = url.protocol === 'https:' && !url.username && !url.password; } catch {}
        input.setCustomValidity(valid ? '' : root.dataset.urlError);
      }
      sync();
    }));
    root.querySelectorAll('[data-spd-style],[data-spd-accent]').forEach(input => input.addEventListener('change', sync));
    root.querySelectorAll('[data-spd-view]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-spd-view]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
      root.querySelectorAll('[data-spd-panel]').forEach(panel => { panel.hidden = panel.dataset.spdPanel !== button.dataset.spdView; });
    }));
    const cleanups = [];
    root.querySelectorAll('[data-spd-upload]').forEach(input => {
      const kind = input.dataset.spdUpload;
      const images = [...root.querySelectorAll(`[data-spd-image="${kind}"]`)];
      const remove = root.querySelector(`[data-spd-remove="${kind}"]`);
      let objectUrl;
      const clear = () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = undefined;
        images.forEach(image => { image.hidden = true; image.removeAttribute('src'); });
        if (kind === 'logo') { const monogram = root.querySelector('[data-spd-monogram]'); if (monogram) monogram.hidden = false; }
        remove.hidden = true;
      };
      input.addEventListener('change', () => {
        clear(); input.setCustomValidity('');
        const file = input.files?.[0];
        if (!file) return;
        remove.hidden = false;
        if (!['image/png','image/jpeg','image/webp'].includes(file.type) || file.size > 5*1024*1024) { input.setCustomValidity(root.dataset.fileError); input.reportValidity(); return; }
        objectUrl = URL.createObjectURL(file);
        images.forEach(image => { image.src = objectUrl; image.hidden = false; });
        if (kind === 'logo') { const monogram = root.querySelector('[data-spd-monogram]'); if (monogram) monogram.hidden = true; }
      });
      remove.addEventListener('click', () => { clear(); input.value = ''; input.setCustomValidity(''); input.focus(); });
      cleanups.push(clear);
    });
    const teardown = () => { cleanups.forEach(clear => clear()); window.removeEventListener('pagehide', teardown); document.removeEventListener('shopify:section:unload', onUnload); };
    const onUnload = event => { if (event.target.contains(root)) teardown(); };
    window.addEventListener('pagehide', teardown, { once:true });
    document.addEventListener('shopify:section:unload', onUnload);
    sync();
  });
}
initializeProductDesigners();
document.addEventListener('shopify:section:load', event => initializeProductDesigners(event.target));
  } catch(e) { console.error(e); }
})();

})();
